import clsx from "clsx";
import React from "react";

export const EmptyCard: React.FC<{
  emptyLabel: string;
  className?: string;
}> = ({ emptyLabel = "No Results", className }) => (
  <div className={clsx("text-muted", className)}>{emptyLabel}</div>
);
